// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__MWmI4","amount":"Amount_amount__g3rdp","tip":"Amount_tip__3Tthv","tipHeader":"Amount_tipHeader__1t8Mr","tipsWrap":"Amount_tipsWrap__11H2f"};